module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), (_vm.isAddDevAccess == false) ? _c('div', {
    staticClass: "no-dev-access"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/home/bg_noDevice.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-size-xs"
  }, [_vm._v("为了保证您正常使用，请将天猫精灵更新至最新版本")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateAppClick
    }
  }, [_vm._v("去升级\n    ")])]) : _c('div', [_c('top-menu'), _vm._v(" "), _c('device-list')], 1), _vm._v(" "), _c('debug-block', {
    attrs: {
      "position": "bottom"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60dcfea0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/Index.vue
// module id = 902
// module chunks = 1